import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { CustomerProvider } from "./context/CustomerContext";
import { CartProvider } from "./context/CartContext";
import { CardsProvider } from "./context/CardsContext";
import { OpenCartProvider } from "./context/OpenCartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
 
  <CardsProvider>
    <CustomerProvider>
      <CartProvider>
      <OpenCartProvider>
        <App />
        </OpenCartProvider>
      </CartProvider>
    </CustomerProvider>
  </CardsProvider>

  // </React.StrictMode>
);
